<template>
  <div class="areaSet">
    <a-form-model layout="inline" style="display: flex; justify-content: space-around">
      <a-form-model-item label="校内学生一致">
        <a-switch :loading="switchLoading" @change="switchChange" :disabled="IsDetails" v-model="uniformity.schoolUniformity" checked-children="启用" un-checked-children="禁用" />
      </a-form-model-item>
      <a-form-model-item v-if="tableRelevant.tableDataSource.length">
        <a-dropdown :trigger="['click']" v-model="dropdownVisible" :disabled="IsDetails">
          <a-button @click="(e) => e.preventDefault()">快速配置学生</a-button>
          <a-menu slot="overlay">
            <!-- <a-menu-item key="0" @change="change0">
              <a-checkbox value="0" v-model="checkboxs.a">未开始</a-checkbox>
            </a-menu-item> -->
            <a-menu-item key="1" @change="change0">
              <a-checkbox value="1" v-model="checkboxs.b">进行中</a-checkbox>
            </a-menu-item>
            <a-menu-item key="2" @change="change0">
              <a-checkbox value="2" v-model="checkboxs.c">已完成</a-checkbox>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item>
              <a-button style="margin-right: 15px" @click="quickSetClose()">取消</a-button>
              <a-button type="primary" @click="quickSet()" :disabled="quickSetStudent.length < 1">确定</a-button>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-form-model-item>
      <a-form-model-item v-if="tableRelevant.tableDataSource.length">
        <a-button @click="resetComputed()" :disabled="IsDetails">重新算分</a-button>
      </a-form-model-item>
      <a-form-model-item v-if="!IsDetails">
        <a-button @click="course.visible = true" type="primary">添加测评</a-button>
      </a-form-model-item>
    </a-form-model>
    <div style="margin: 30px auto; width: 95%">
      <a-table
        @expand="expandedRowsChange"
        :expandedRowKeys="tableExpandedRowKeys"
        :columns="columns"
        row-key="organizationName"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :dataSource="tableRelevant.tableDataSource"
      >
        <div slot="organizationName" slot-scope="text"><span v-if="text.hasAnonymous">【匿名】</span>{{ text.organizationName }}</div>
        <div slot="student" slot-scope="text">{{ text.userCount }}/{{ text.totalCount }}</div>
        <div slot="action" slot-scope="text">
          <a-switch @change="tableSwitchChange(text)" v-model="text.hasAnonymous" checked-children="匿名" :disabled="IsDetails" un-checked-children="不匿名" />
        </div>
        <StepsSecondCourse
          slot-scope="text"
          slot="expandedRowRender"
          :uniformity="uniformity"
          :IsDetails="IsDetails"
          @renewData="getGroupReportCourseInfo"
          @loading="(bool) => (text.tableLoading = bool)"
          :tableLoading="text.tableLoading"
          :tableDataSource="text.groupCourseInfos"
        />
      </a-table>
    </div>
    <!-- 添加测评 -->
    <a-modal v-model="course.visible" title="添加测评" width="70%" @ok="courseSubmit" :confirm-loading="course.confirmLoading" :destroyOnClose="true">
      <StepsSecondAddCourse :key="course.key" :select-data="selectTableData" ref="addCourse" />
    </a-modal>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import StepsSecondAddCourse from '@/pages/reportCenter/groupReport_new/components/StepsSecondAddCourse'
import StepsSecondCourse from '@/pages/reportCenter/groupReport_new/components/StepsSecondCourse'

export default {
  name: 'AreaSet',
  props: {
    IsDetails: {
      type: Boolean,
      default: false,
    },
  },
  components: { StepsSecondAddCourse, StepsSecondCourse },
  data() {
    return {
      uniformity: {
        schoolUniformity: this.$store.getters['organization/getReportInfo'].studentSampleTakingMethod === 2,
        sampleInsideUniformity: undefined,
        sampleOutsideUniformity: undefined,
      },
      columns: [
        { title: '机构名称', scopedSlots: { customRender: 'organizationName' } },
        { title: '学生数', scopedSlots: { customRender: 'student' } },
        { title: '操作', scopedSlots: { customRender: 'action' } },
      ],
      tableRelevant: tableRelevant.call(this),
      course: {
        key: Date.now(),
        visible: false,
        confirmLoading: false,
      },
      switchLoading: false,
      tableExpandedRowKeys: [], //表格展开的行
      selectTableData: [],
      dropdownVisible: false,
      quickSetStudent: [],
      checkboxs: {
        a: false,
        b: false,
        c: false,
      },
    }
  },
  watch: {
    dropdownVisible(val) {
      if (!val) {
        this.quickSetStudent = []
        this.checkboxs = {
          a: false,
          b: false,
          c: false,
        }
      }
    },
  },
  mounted() {
    this.getGroupReportCourseInfo()
  },
  methods: {
    change0(e) {
      if (e.target.checked) {
        this.quickSetStudent.push(+e.target._value)
      } else {
        this.quickSetStudent = this.quickSetStudent.filter((f) => f != e.target._value)
      }
    },
    quickSetClose() {
      this.dropdownVisible = false
      this.quickSetStudent = []
      this.checkboxs = {
        a: false,
        b: false,
        c: false,
      }
    },
    // 快速配置学生
    quickSet() {
      let params = {
        groupReportId: this.$store.getters['organization/getReportInfo'].id,
        userCourseSessionStatus: this.quickSetStudent,
      }
      this.$http.ReportService.configGroupStudent(params).then((res) => {
        this.$message.destroy()
        const { status, data, message } = res
        this.$message.success(message)
        this.getGroupReportCourseInfo()
        this.dropdownVisible = false
        this.quickSetStudent = []
        this.checkboxs = {
          a: false,
          b: false,
          c: false,
        }
      })
    },
    // 重新算分
    resetComputed() {
      let that = this
      this.$confirm({
        title: '确认重新算分?',
        content: '重新算分后原有分数将被清空，请确认此操作',
        onOk() {
          let formData = new FormData()
          that.tableRelevant.tableDataSource.forEach((v) => {
            v.items.forEach((i) => {
              formData.append('customerChildCourseIds', i.projectCourseChildId)
              formData.append('customerCourseIds', i.projectCourseConfigId)
            })
          })
          that.$http.GroupReport.GroupReportUpdateCourseContentScore(formData).then((res) => {
            that.$message.destroy()
            const { status, data, message } = res
              that.$message.success(message)

          })
        },
        onCancel() {},
      })
    },
    // 展开行
    expandedRowsChange(expanded, record) {
      if (expanded) {
        this.tableExpandedRowKeys.push(record.organizationName)
      } else {
        this.tableExpandedRowKeys.splice(this.tableExpandedRowKeys.indexOf(record.organizationName), 1)
      }
    },
    switchChange(checked) {
      const reportInfo = this.$store.getters['organization/getReportInfo']
      const Params = {
        groupReportId: reportInfo.id,
        studentSampleTakingMethod: checked ? 2 : 0,
      }
      this.switchLoading = true
      this.$http.GroupReport.updateStudentSampleTakingMethod(Params).then((res) => {
        const { status, data, message } = res
          this.$message.success(message)
          this.getGroupReportCourseInfo()
          this.$store.commit('organization/setReportInfo', {
            ...reportInfo,
            studentSampleTakingMethod: Params.studentSampleTakingMethod,
          })

      }).catch(e => {
        this.switchLoading = false
      })
    },
    tableSwitchChange(val) {
      const Form = new FormData()
      Form.append('id', val.groupReportSampleId)
      Form.append('sampleName', val.hasAnonymous ? '学校' + (val.index + 1) : val.organizationName)
      Form.append('groupReportId', this.$store.getters['organization/getReportInfo'].id)
      this.tableRelevant.tableLoading = true
      this.$http.GroupReport.editSample(Form).then((res) => {
        const { status, message } = res
          this.$message.success(message)

      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
    // 获取团体报告配置课程信息
    getGroupReportCourseInfo() {
      const id = this.$store.getters['organization/getReportInfo'].id
      if (!id) return
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.groupReportCourse(id)
        .then((res) => {
          this.switchLoading = false
          const { status, data, message } = res
          this.tableRelevant.tableDataSource = data
          this.selectTableData = data.reduce((pre, cur) => {
            return pre.concat(cur.groupCourseInfos)
          }, [])
          console.log(this.selectTableData);
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    addRound() {
      this.course.visible = true
      this.course.key = Date.now()
    },
    // 添加测评
    courseSubmit() {
      this.$message.destroy()
      if (!this.$refs.addCourse.selectedRowKeys.length) {
        this.$message.warning('请选择测评')
        return
      }
      this.course.confirmLoading = true
      const params = {
        groupReportId: this.$store.getters['organization/getReportInfo'].id,
        params: this.$refs.addCourse.selectedRows.map(m => ({
          organizationId: m.organizationId,
          organizationCourseId: m.projectCourseConfigId,
          organizationCourseSessionId: m.id,
        })),
      }
      this.$http.ReportService.addGroupReportCourse(params).then((res) => {
        this.course.confirmLoading = false
        const { status, data, message } = res
        this.course.visible = false
        this.$message.success(message)
        this.getGroupReportCourseInfo()
      })
    },
  },
}
</script>
